// User-facing copy for CollectPhoneTimezoneModal (AI Coordinator phone capture).
// Kept in one object so copy can be reviewed/updated in a single place.
export const COLLECT_PHONE_TIMEZONE_COPY = {
  title: 'No phone number and timezone.',
  description:
    'Candidate needs a valid phone number and timezone setup to be called by Kula Coordinator.',
  phoneLabel: 'Phone number',
  phonePlaceholder: 'Add phone number',
  phoneRequiredError: 'Phone number is required',
  invalidPhoneError: 'Invalid phone number',
  saveSuccess: "We've saved your phone number and timezone.",
  saveError: "We couldn't save. Please try again.",
  cancel: 'Cancel',
  update: 'Update',
};
